import $ from "jquery";
import "magnific-popup";

class Popup {
    constructor() {
        this.bindEvents();
    }

    bindEvents() {
        let that = this;
        if ($('.popup-video').length != 0) {
            $('.popup-video').magnificPopup({
                disableOn: 700,
                type: 'iframe',
                mainClass: 'mfp-fade',
                removalDelay: 300,
                preloader: false,
                fixedContentPos: false
            });
        }
    }
}

export default new Popup;